import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { createViewEventElement } from '@shopify/events';

export class CartItemsComponent extends createViewEventElement(Component) {
  static get pendingQuantityUpdates() { return []; }
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener(ThemeEvents.quantitySelectorUpdate, this.onQuantityChange);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener(ThemeEvents.quantitySelectorUpdate, this.onQuantityChange);
  }
  async fetchCartData() {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store'
    });
    if (!response.ok) throw new Error('Unable to read the cart.');
    return response.json();
  }
  onQuantityChange = (event) => {
    const row = event.target.closest('[data-nemo-line]');
    if (row) window.NemoCart?.change(row, Number(event.detail.quantity));
  };
  onLineItemRemove(line) {
    const row = this.querySelector(`[data-nemo-line="${Number(line)}"]`);
    if (row) window.NemoCart?.change(row, 0);
  }
}
if (!customElements.get('cart-items-component')) customElements.define('cart-items-component', CartItemsComponent);
